import { useEffect, useState } from 'react';
import { fetchCaratPlanningsRequest } from '@/services/api/carat';
import { processAPIResponseNow } from '@/utils/request';
import { CaratPlanningModel } from '@/typings/models/CaratModel';

/**
 * Carat plannings attached to one lead (CLICKUP-86cb5zayy). Only called when
 * the partner has the Deal Manager module and the Carat app installed, so a
 * failure here is a real error rather than a missing entitlement.
 */
export const useCaratPlannings = (leadId?: string) => {
  const [plannings, setPlannings] = useState<CaratPlanningModel[]>([]);
  const [loading, setLoading] = useState(Boolean(leadId));

  useEffect(() => {
    if (!leadId) {
      setPlannings([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    fetchCaratPlanningsRequest({ leadId })
      .then((Response) => {
        processAPIResponseNow(
          Response,
          { onSuccess: (data) => setPlannings(data || []) },
          'data.data',
        );
      })
      .finally(() => setLoading(false));
  }, [leadId]);

  return { plannings, loading };
};
